// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"cb056a29","455":"3343d83f","977":"2bd34e5b"}[chunkId] + ".chunk.js";
};